import {
    setAIVoiceFiltersRequestStarted,
    setAIVoiceFiltersRequestSucceeded,
    setAttributes,
} from './ai-voice-filters-slice';

import { AIVoiceFilterTypeEnum, ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';
import uuid from 'js/src/libs/uuid';

export const fetchAIVoiceFiltersByFilterType = (filterType: AIVoiceFilterTypeEnum) => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceFilterList({
                query: { [filterType]: true },
            });
            dispatch(setAttributes({ filterType, data: response.data }));
        } catch (error) {
            ErrorReporter.capture(error);
        }
    };
};

export const fetchAIVoicePublicFilters = () => {
    return async (dispatch: AppDispatch) => {
        const requestId = uuid();
        dispatch(setAIVoiceFiltersRequestStarted(requestId));
        const filterTypes: AIVoiceFilterTypeEnum[] = [
            AIVoiceFilterTypeEnum.ACCENT,
            AIVoiceFilterTypeEnum.AGE,
            AIVoiceFilterTypeEnum.GENDER,
            AIVoiceFilterTypeEnum.LANGUAGE,
            AIVoiceFilterTypeEnum.STYLE,
            AIVoiceFilterTypeEnum.TONE,
        ];
        await Promise.allSettled(
            filterTypes.map((filterType) => dispatch(fetchAIVoiceFiltersByFilterType(filterType))),
        );
        dispatch(setAIVoiceFiltersRequestSucceeded({ requestId }));
    };
};
